import Vue from 'vue'
import Router from 'vue-router'
import IntakeSurvey from '../views/IntakeSurvey.vue'
import SubmitSuccess from '../views/SubmitSuccess.vue'
import ReportQuery from '../views/ReportQuery.vue'
import Home from '../views/Home.vue'
import ProjectList from '../views/OrderList.vue'
import ProjectDetail from '../views/OrderDetail.vue'
import PdfPreview from '../views/PdfPreview.vue'
import Login from '../views/Login.vue'
import { getToken } from '../utils/auth'
import { readEntryQuery } from '../utils/session'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/consent-promotion',
      name: 'ConsentPromotionAdmin',
      component: () => import('../features/consent/ConsentPromotionAdmin.vue'),
      meta: { hideTabBar: true, public: true }
    },
    {
      path: '/consent',
      name: 'Consent',
      component: () => import('../features/consent'),
      meta: { hideTabBar: true, public: true }
    },
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { hideTabBar: true, public: true }
    },
    {
      path: '/intake',
      name: 'IntakeSurvey',
      component: IntakeSurvey,
      meta: { hideTabBar: true }
    },
    {
      path: '/success',
      name: 'SubmitSuccess',
      component: SubmitSuccess,
      meta: { hideTabBar: true }
    },
    {
      path: '/report',
      name: 'ReportQuery',
      component: ReportQuery
    },
    {
      path: '/projects',
      name: 'ProjectList',
      component: ProjectList
    },
    {
      path: '/projects/:projectId',
      name: 'ProjectDetail',
      component: ProjectDetail
    },
    {
      path: '/pdf-preview',
      name: 'PdfPreview',
      component: PdfPreview,
      meta: { hideTabBar: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const entryQuery = readEntryQuery(to)
  if (to.name === 'Login' && entryQuery.ticket) {
    next({
      path: '/home',
      query: Object.assign({}, entryQuery)
    })
    return
  }
  if (to.meta.public || getToken() || entryQuery.ticket) {
    next()
    return
  }
  next({
    path: '/login',
    query: { redirect: to.fullPath }
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js